import React, { useEffect, useState } from "react";
import { api, formatApiError } from "../lib/api";
import { X, Download, Loader2, Eye } from "lucide-react";
import { toast } from "sonner";

export default function PdfPreviewModal({ cid, module, title, onClose }) {
  const [url, setUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [filename, setFilename] = useState(`${module}_${cid}.pdf`);

  useEffect(() => {
    let objectUrl = null;
    (async () => {
      try {
        const res = await api.get(`/clienti/${cid}/${module}/pdf`, { responseType: "blob" });
        const cd = res.headers["content-disposition"] || "";
        const m = cd.match(/filename="?([^";]+)"?/);
        if (m) setFilename(m[1]);
        objectUrl = URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
        setUrl(objectUrl);
      } catch (err) {
        toast.error(formatApiError(err));
        onClose();
      } finally {
        setLoading(false);
      }
    })();
    return () => { if (objectUrl) URL.revokeObjectURL(objectUrl); };
    // eslint-disable-next-line
  }, [cid, module]);

  const download = () => {
    const a = document.createElement("a");
    a.href = url; a.download = filename;
    document.body.appendChild(a); a.click(); a.remove();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{ background: "rgba(0,0,0,0.55)" }}
      onClick={onClose} data-testid="pdf-preview-modal">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-5xl h-[90vh] flex flex-col overflow-hidden"
        onClick={(e) => e.stopPropagation()}>
        <div className="px-4 py-3 border-b flex items-center justify-between" style={{ borderColor: "var(--border)" }}>
          <div className="flex items-center gap-2 min-w-0">
            <Eye className="w-4 h-4 flex-shrink-0" style={{ color: "var(--primary)" }} />
            <div className="font-bold text-sm truncate" style={{ fontFamily: "Manrope" }}>
              Anteprima PDF · {title}
            </div>
          </div>
          <div className="flex items-center gap-2">
            <button onClick={download} disabled={!url} className="btn-primary text-xs" data-testid="pdf-preview-download">
              <Download className="w-3.5 h-3.5" /> Scarica
            </button>
            <button onClick={onClose} className="p-1.5 rounded hover:bg-black/5" data-testid="pdf-preview-close">
              <X className="w-4 h-4" />
            </button>
          </div>
        </div>
        <div className="flex-1 min-h-0" style={{ background: "#525659" }}>
          {loading ? (
            <div className="h-full flex items-center justify-center text-white text-sm gap-2">
              <Loader2 className="w-5 h-5 animate-spin" /> Generazione PDF in corso…
            </div>
          ) : (
            <iframe src={url} title="Anteprima PDF" className="w-full h-full border-0" data-testid="pdf-preview-iframe" />
          )}
        </div>
      </div>
    </div>
  );
}
